'use client';

import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  category: string;
  features: {
    name: string;
    free: boolean | string;
    pro: boolean | string;
    premium: boolean | string;
  }[];
}

interface ComparisonTableProps {
  data: ComparisonFeature[];
}

export default function ComparisonTable({ data }: ComparisonTableProps) {
  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="CheckIcon" variant="solid" size={20} className="text-success mx-auto" />
      ) : (
        <Icon name="XMarkIcon" size={20} className="text-muted-foreground mx-auto" />
      );
    }
    return <span className="text-sm text-foreground">{value}</span>;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-4 px-6 font-heading font-semibold text-foreground">Features</th>
            <th className="text-center py-4 px-6 font-heading font-semibold text-foreground">Free</th>
            <th className="text-center py-4 px-6 font-heading font-semibold text-primary">Pro</th>
            <th className="text-center py-4 px-6 font-heading font-semibold text-foreground">Premium</th>
          </tr>
        </thead>
        <tbody>
          {data.map((category, categoryIndex) => (
            <>
              <tr key={`category-${categoryIndex}`} className="bg-muted">
                <td colSpan={4} className="py-3 px-6 font-heading font-semibold text-foreground">
                  {category.category}
                </td>
              </tr>
              {category.features.map((feature, featureIndex) => (
                <tr key={`feature-${categoryIndex}-${featureIndex}`} className="border-b border-border hover:bg-muted/50 transition-colors duration-200">
                  <td className="py-4 px-6 text-sm text-foreground">{feature.name}</td>
                  <td className="py-4 px-6 text-center">{renderValue(feature.free)}</td>
                  <td className="py-4 px-6 text-center">{renderValue(feature.pro)}</td>
                  <td className="py-4 px-6 text-center">{renderValue(feature.premium)}</td>
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}